/**
 * GradeTable — grade specification table.
 * Shared by chapters 2726..2729 (CX-2725 §3).
 */

import type { GradeTable as GradeTableData } from "../chapter.types";
import "./GradeTable.css";

interface GradeTableProps {
  table: GradeTableData;
}

export const GradeTable = ({ table }: GradeTableProps) => (
  <section className="grade-table">
    {table.title && <h3 className="grade-table__title">{table.title}</h3>}
    <div className="grade-table__scroll">
      <table className="grade-table__table">
        <thead>
          <tr>
            {table.columns.map((column) => (
              <th key={column} scope="col">
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {table.rows.map((row) => (
            <tr key={row.join("|")}>
              {row.map((cell, cellIndex) => (
                <td
                  key={`${row.join("|")}-${cellIndex}`}
                  className={
                    cellIndex === row.length - 1
                      ? "grade-table__cell--wrap"
                      : undefined
                  }
                >
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </section>
);
